import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';

import { Button, ButtonSize, ButtonType } from '../Button';

export interface MessageComposerProps {
  value: string;
  onChange: (next: string) => void;
  onSend: () => void;
  isSending?: boolean;
  maxLength?: number;
  recipientName?: string;
  ariaLabel?: string;
  placeholder?: string;
  sendAriaLabel?: string;
  inputId?: string;
  sendButtonId?: string;
}

export const MessageComposer = ({
  value,
  onChange,
  onSend,
  isSending = false,
  maxLength = 3000,
  recipientName,
  ariaLabel,
  placeholder,
  sendAriaLabel = 'Send message',
  inputId = 'send-message',
  sendButtonId = 'add-to-thread',
}: MessageComposerProps): JSX.Element => {
  const resolvedAriaLabel = ariaLabel ?? (recipientName ? `Message to ${recipientName}` : 'Message');
  const resolvedPlaceholder = placeholder ?? (recipientName ? `Type a message to ${recipientName}...` : 'Type a message...');

  return (
    <div className='mt-3'>
      <textarea
        id={inputId}
        className='form-control w-full border border-neutral-300 rounded p-2'
        rows={3}
        aria-label={resolvedAriaLabel}
        placeholder={resolvedPlaceholder}
        maxLength={maxLength}
        value={value}
        onChange={(e): void => onChange(e.target.value)}
      />
      <Button
        id={sendButtonId}
        buttonType={ButtonType.primary}
        buttonSize={ButtonSize.small}
        aria-label={sendAriaLabel}
        className='mt-2 !w-11 !h-11 !min-w-0 !p-0 !rounded-full inline-flex items-center justify-center float-right'
        onClick={onSend}
        disabled={!value.trim() || isSending}
      >
        <FontAwesomeIcon icon={faPaperPlane} className='text-lg' />
      </Button>
      <div className='clear-both' />
    </div>
  );
};
